import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function PetAdaptivePolicySummary({ policy }) {
    return _jsxs("p", { children: [_jsx("strong", { children: "Adaptive rounds: " }), policy.version === 2 && policy.adaptive ? _jsxs(_Fragment, { children: ["Up to ", policy.adaptive.maxRounds, ". All rounds share the existing execution limits; each recipient must preview and activate their own Setup."] }) : 'Off. The setup uses one accepted plan.'] });
}
/** Comparison values are the server's complete policy/source-role structure. */
export function PetAdaptiveComparison({ value }) {
    if (!value || typeof value !== 'object' || !('policy' in value))
        return null;
    const policy = value.policy;
    if (!policy || typeof policy !== 'object' || !('version' in policy))
        return null;
    const adaptive = policy.version === 2 && 'adaptive' in policy ? policy.adaptive : null;
    const rounds = adaptive && typeof adaptive === 'object' && 'maxRounds' in adaptive ? adaptive.maxRounds : null;
    return _jsxs("p", { children: [_jsx("strong", { children: "Adaptive rounds: " }), typeof rounds === 'number' && Number.isInteger(rounds) ? `Up to ${rounds}` : 'Off'] });
}
//# sourceMappingURL=PetAdaptivePolicySummary.js.map